import { render, staticRenderFns } from "./LogFiles.vue?vue&type=template&id=588c3b72&scoped=true"
import script from "./LogFiles.vue?vue&type=script&lang=js"
export * from "./LogFiles.vue?vue&type=script&lang=js"
import style0 from "./LogFiles.vue?vue&type=style&index=0&id=588c3b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588c3b72",
  null
  
)

export default component.exports